<template>
  <div class="room-container clearfix">
    <div class="left">
      <tab-list ref="tabList" @selectItem="getList"></tab-list>
    </div>
    <div class="right">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="handleNew(floorCode, name)"
        >{{ $t("app.new") }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        icon="el-icon-refresh"
        @click="updateStatus()"
        >狀態更新</el-button
      >
      <el-table :data="tableData" style="width: 100%" stripe>
        <el-table-column align="left" :label="$t('app.operation')">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="handleEdit(scope.$index, scope.row, name)"
              >{{ $t("app.edit") }}</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="handleDelete(scope.$index, scope.row)"
              >{{ $t("app.delete") }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('app.roomCode')" prop="code">
        </el-table-column>
        <el-table-column align="center" :label="$t('app.roomType')" prop="type">
          <template slot-scope="scope">
            {{ roomTypeList[scope.row.type].text }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('app.roomStatus')"
          prop="status"
        >
          <template slot-scope="scope">
            {{ statusList[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('app.roomRemark')"
          prop="remark"
        >
        </el-table-column>
        <el-table-column align="right" :label="$t('app.enable')">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              @change="roleEnable(scope.row, scope.row.enable)"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: center; margin-top: 20px"
        background
        :total="total"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="changePage"
        :page-sizes="[10, 50, 200, 1000]"
        :page-size="size"
        layout="total, sizes, prev, pager, next"
      >
      </el-pagination>
      <room-edit
        ref="editModal"
        @handleSuccess="update"
        @handleAdd="add"
      ></room-edit>
    </div>
  </div>
</template>
<script>
import RoomEdit from "./modules/RoomEdit";
import TabList from "./modules/TabList";
import { getRoomType } from "@/api/guest/appointment";
import {
  getRoomList,
  deleteRoom,
  enableRoom,
  disableRoom,
  updateStatus
} from "@/api/systemManagement/roomManagement";
export default {
  components: {
    TabList,
    RoomEdit
  },
  data() {
    return {
      roomTypeList: {
        1: "Single",
        2: "Twin",
        3: "Double",
        4: "Suite",
        5: "Tes111t"
      },
      statusList: {
        1: "Vacant Clean",
        0: "Not Vacant Clean"
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      floorCode: "",
      name: "",
      id: ""
    };
  },
  mounted() {
    this.init();
    this.$refs.tabList.init();
  },

  methods: {
    init() {
      // 查询接口，取得房间类型 laotang 2023-05-09
      getRoomType().then(res => {
        var len = res.data.length;
        this.roomTypeList[0] = {};
        for (var i = 0; i < len; i++) {
          var code = res.data[i].Code;
          var text = res.data[i].Text;
          console.log(code + "          " + text);
          this.roomTypeList[i + 1] = { code, text };
        }
      });
    },
    changePage() {
      this.getList();
    },
    getList(obj) {
      if (obj) {
        this.floorCode = obj.code;
        this.name = obj.name;
      }
      getRoomList({
        FloorCode: this.floorCode,
        PageSize: this.size,
        PageIndex: this.currentPage
      }).then(res => {
        if (res.data.Total === 0) {
          this.total = 0;
          this.tableData = [];
        } else {
          this.total = res.data.Total;
          this.tableData = res.data.Items.map(item => {
            return {
              floorCode: item.FloorCode,
              id: item.Id,
              code: item.RoomIndex,
              type: item.RoomType,
              status: item.RoomState,
              enable: item.IsUse,
              remark: item.Remark,
              bedList: item.BedGroup.map(item => {
                return {
                  code: item.BedCode,
                  status: item.BedState
                };
              })
            };
          });
        }
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleNew(floor, name) {
      console.log("floor: " + floor + "  name: " + name);
      this.$refs.editModal.new(floor, name);
    },
    handleEdit(index, row, name) {
      console.log("handleEdit: " + index + " " + row + " " + name);
      this.$refs.editModal.edit(index, row, name);
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("app.isDelete") + "?(" + row.code + ")").then(
        () => {
          deleteRoom({ RoomIndex: row.code }).then(() => {
            this.getList();
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success"
            });
          });
        }
      );
    },
    roleEnable(row, val) {
      if (val) {
        enableRoom({ RoomIndex: row.code })
          .then(() => {
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success"
            });
          })
          .catch(() => {
            row.enable = false;
          });
      } else {
        disableRoom({ RoomIndex: row.code })
          .then(() => {
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success"
            });
          })
          .catch(() => {
            row.enable = true;
          });
      }
    },
    update() {
      this.getList();
    },
    add() {
      this.getList();
    },
    updateStatus() {
      updateStatus()
        .then(() => {
          this.$notify({
            title: this.$t("app.success"),
            message: this.$t("app.opeSuccess"),
            type: "success"
          });
          this.getList();
        })
        .catch();
    }
  }
};
</script>
<style lang="scss" scoped>
.room-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .left {
    float: left;
    width: 200px;
    height: 100%;
  }
  .right {
    float: right;
    width: calc(100% - 200px);
    height: 100%;
    overflow: auto;
  }
}
</style>
